import { InjectionToken } from '@angular/core';

export const USER_OPTIONS: InjectionToken<string> = new InjectionToken(
	'scheduler user options'
);
